import React from 'react';
import { Route, Redirect, } from 'react-router-dom';
import routes from '../routes';
import _ from 'lodash';

export const checkPermission = ({ permissions = [] }) => {
  let userPermissions = ((localStorage.getItem('getUserPermissionList') && JSON.parse(localStorage.getItem('getUserPermissionList'))) || []);
  let permission = permissions.find(a => userPermissions.indexOf(a) > -1);
  return (permission == undefined || permission == null) ? false : permission;
};

export const getDefaultRoute = (defaultRoute) => {
  let route = ((localStorage.getItem('defaultRoute') && JSON.parse(localStorage.getItem('defaultRoute'))) || {});
  let mainRoute = ((localStorage.getItem('defaultMainRoute') && JSON.parse(localStorage.getItem('defaultMainRoute'))) || {});
  return (route[defaultRoute] || mainRoute);
};

export const PrivateRoute = ({ component: Component, ...rest }) => {
  let defaultRoute = getDefaultRoute(rest.defaultRoute);
  return (
    <Route {...rest} render={(props) => (
      checkPermission(rest)
        ? <Component {...props} {...rest} />
        : defaultRoute && typeof defaultRoute == 'string' ? <Redirect to={{
          pathname: `${defaultRoute}`,
          state: { from: props.location }
        }} /> : <Redirect to={{
          pathname: `/${routes.mainRoute}/${routes.notAuthorize}`,
          state: { from: props.location }
        }} />
    )} />
  )
};


export const checkTablePermissionForRedirectDashboard = (permission, options) => {

  let userPermission = ((localStorage.getItem('getUserPermissionList') && JSON.parse(localStorage.getItem('getUserPermissionList'))) || []);

  if (!userPermission.find((a) => a == permission.dashboard)) {
    options.actions = options.actions.filter((a) => a.type != 'chart');
  }

  return options;

};


export const checkTablePermission = (permission, options) => {

  let userPermission = ((localStorage.getItem('getUserPermissionList') && JSON.parse(localStorage.getItem('getUserPermissionList'))) || []);

  if (!userPermission.find((a) => a == permission.edit)) {
    options.actions = options.actions.filter((a) => a.type != 'edit');
    // options.actions = options.actions.filter((a) => a.type != 'viewRule');
    // options.actions = options.actions.filter((a) => a.type != "clone")
    let viewPermission = userPermission.find((a) => a == permission.view);
    if (viewPermission) {
      options.actions = options.actions.filter((a) => (a.type == 'view' || a.type == 'viewRule'));
    }
    options.recActive = false;
    options.actionsThead = (permission.view && !viewPermission) ? false : true;
  }

  // if (!userPermission.find((a) => a == permission.selection)) {
  //   if (options['selection']) {
  //     options.selection.show = false;
  //   }
  // }

  if (permission.delete && !userPermission.find((a) => a == permission.delete)) {
    options.actions = options.actions.filter((a) => !(a.type == 'delete' || a.type == 'remove'));
  }

  if (permission.sync && !userPermission.find((a) => a == permission.sync)) {
    options.actions = options.actions.filter((a) => !(a.type == 'sync'));
  }

  if (permission.download && !userPermission.find((a) => a == permission.download)) {
    options.actions = options.actions.filter((a) => !(a.type == 'download'));
  }

  return options;
};


export const checkAddPermission = (type) => {
  let userPermission = ((localStorage.getItem('getUserPermissionList') && JSON.parse(localStorage.getItem('getUserPermissionList'))) || []);
  return userPermission.find((a) => a == type);
};
